

// step
export const CHECKOUT_SHIPPING = "checkout shipping";
export const CHECKOUT_PROJECT_INFORMATION = "checkout project information";
export const CHECKOUT_REVIEW_BASKET = "checkout review basket";
export const CHECKOUT_ORDER_CONFIRMATION = "checkout order confirmation";


// select item to checkout
export const CHECKOUT_TYPE_MIXED = "Mixed";
export const CHECKOUT_TYPE_SITE = "Site";
export const CHECKOUT_TYPE_PROJECT = "Project";
export const CHECKOUT_TYPE_TRAY = "Tray";

// list items
export const BASKET_SITEITEMS = "SiteItems";
export const BASKET_PROJECTITEMS = "ProjectItems";
export const BASKET_TRAYITEMS = "TrayItems";

export const SAMPLE_TYPE_FULL = "Full";
export const SAMPLE_TYPE_CUT = "Cut"